export default function getValidToken(value) {
    // 有时候router里面会存在多个token，导致取到的token为数组，需要处理
    if (Array.isArray(value)) {
        const newList = value.filter((key) => key !== 'undefined')
        const length = newList?.length
        return value[length - 1]
    }
    else if (value) {
        return value
    }
    else {
        return ''
    }
}
